import { render, staticRenderFns } from "./lucky-event-modal.vue?vue&type=template&id=65bb0c1a&"
import script from "./lucky-event-modal.vue?vue&type=script&lang=js&"
export * from "./lucky-event-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports